import { ensureArray } from "lib/ensure-array"

export function omit(object, ...list) {
    list = list.map(ensureArray).flat(Infinity)
    const output = { ...object }
    list.forEach((p) => delete output[p])
    return output
}
